/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { type APIPermissions, NewFeaturePermissions } from '@poweralpha/common';

export const hasAgentPermission = (permissions: Array<APIPermissions> | undefined) =>
  permissions?.includes(NewFeaturePermissions.BETA) ?? false;
